/* eslint-disable import/no-anonymous-default-export */

export default (status = '', action) => {
    if (action.type === 'EMAIL_SIGNUP' || action.type === 'EMAIL_LOGIN' || action.type === 'LINKEDIN_LOGIN' || action.type === 'LINKEDIN_SIGNUP' || action.type === 'UPDATE_TOKEN') {
        return action.payload.token;
    }

    if (action.type === 'LOGOUT_USER') {
        return '';
    }

    return status;
};